import React, { useState, useEffect } from 'react';
import { premiumService, UserPremiumFeatures } from '../../services/premiumService';
import { useAuthStore } from '../../store/authStore';
import UpgradeModal from '../modals/UpgradeModal';

interface ChatUpgradeCardProps {
  groupId: string;
}

const ChatUpgradeCard: React.FC<ChatUpgradeCardProps> = ({ groupId: _groupId }) => {
  const [features, setFeatures] = useState<UserPremiumFeatures | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const { updateUser } = useAuthStore();

  useEffect(() => {
    loadFeatures();
  }, []);

  const loadFeatures = async () => {
    try {
      const userFeatures = await premiumService.getUserFeatures();
      setFeatures(userFeatures);
    } catch (error) {
      console.error('Failed to load premium features:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpgradeComplete = () => {
    // Reload features to reflect the upgrade
    loadFeatures();

    // Update auth store to immediately reflect chat enhancements
    updateUser({ chatEnhancements: true });

  };

  // Don't show if user already has chat enhancements or still loading
  if (isLoading || features?.chatEnhancements) {
    return null;
  }

  return (
    <>
      <div className="sf-card-highlight p-4 mb-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center">
            <div className="flex-shrink-0 text-2xl mr-3">
              🍺
            </div>
            <div className="flex-1">
              <span className="text-sm font-medium text-fg-soft">
                <strong className="text-fg-bright">Is het gezellig?</strong> Steun Solofix met de prijs van een biertje!
              </span>
              <span className="text-sm text-fg-muted ml-2">
                Dan kan jij daarna GIFjes én foto's rondsmijten in chat!
              </span>
            </div>
          </div>
          <div className="flex-shrink-0">
            <button
              onClick={() => setShowUpgradeModal(true)}
              className="sf-btn-primary px-4 py-2 text-sm min-h-[44px]"
            >
              Proost op Solofix!
            </button>
          </div>
        </div>
      </div>

      {/* Upgrade Modal */}
      <UpgradeModal
        isOpen={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
        upgradeType="CHAT_ENHANCEMENTS"
        onUpgradeComplete={handleUpgradeComplete}
      />
    </>
  );
};

export default ChatUpgradeCard;